

























































// Vue
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";

// Constants
import RouteNames from "@/constants/route-names.ts";
import Assets from "@/constants/assets.ts";

// Components
import Icon, { IconEnum } from "@/shared/components/icon.component.vue";
import ItemThumb, {
  ItemThumbPrefeginedStyle
} from "@/shared/components/item-thumb.component.vue";
import ProductCategoryCard, {
  SubtitleColor,
  ProductCategory
} from "@/shared/components/product-category.component.vue";

// Services
import {
  ConvocationService,
  TypeOfProduct
} from "@/manager/convocation/convocation.service";

// Filters
import formatDate from "@/shared/filters/formatDate.filter.ts";

// Models-Interfaces
import { TimetablesInterface } from "@/shared/interfaces/timetables.interface";

@Component({
  components: {
    Icon,
    ItemThumb,
    ProductCategoryCard
  },
  computed: {
    ...mapGetters({
      getConvocation: "getConvocation"
    })
  },
  filters: {
    formatDate
  }
})
export default class ProductCategoryView extends Vue {
  @Prop() private id!: string;

  private assets = Assets;
  private iconEnum = IconEnum;
  private getConvocation!: any;
  private convocationDetailLoaded = false;
  private productCategoryContent = {
    title: "Prueba",
    subtitle: { text: "Subtítulo", color: SubtitleColor.Secondary }
  };

  private created() {
    this.fetchConvocation();
  }

  get productCategories(): ProductCategory[] {
    return [
      {
        id: TypeOfProduct[TypeOfProduct.Course].toLowerCase(),
        type: TypeOfProduct.Course,
        image: Assets.productCourses,
        title: "cursos",
        subtitle: {
          text: "x ventas",
          color: SubtitleColor.Primary
        }
      },
      {
        id: TypeOfProduct[TypeOfProduct.Book].toLowerCase(),
        title: "libros",
        type: TypeOfProduct.Book,
        subtitle: {
          text: "x ventas",
          color: SubtitleColor.Secondary
        }
      },
      {
        id: TypeOfProduct[TypeOfProduct.Merchandising].toLowerCase(),
        title: "merchandising",
        type: TypeOfProduct.Merchandising,
        subtitle: {
          text: "x ventas",
          color: SubtitleColor.Secondary
        }
      }
    ];
  }

  get convocation() {
    return this.getConvocation(this.id);
  }

  private get specialAnnouncement() {
    return this.$route.query.specialAnnouncement;
  }

  get location() {
    let result: string | undefined = "Sin ubicación";
    if (this.specialAnnouncement) {
      result = "Convocatoria especial";
    } else if (this.convocation.location) {
      result = this.convocation.location.name;
    }
    return result;
  }

  get productName() {
    return this.convocation.product.name;
  }

  get formatConvocationDates(): string {
    return ConvocationService.formatDates(this.convocation
        .timetables as TimetablesInterface[]);
  }

  get participantPotential() {
    let numOfPotentials = 0;
    if (this.convocation) {
      numOfPotentials = this.convocation.totalParticipantPotential;
    }
    return numOfPotentials;
  }

  private back() {
    this.$router.push({ name: RouteNames.cbConvocationList });
  }

  private fetchConvocation(
      callback: any = () => {
        const doNothing = 1;
      }
  ) {
    this.$store
        .dispatch("fetchConvocation", {
          id: this.id
        })
        .then((res: any) => {
          this.convocationDetailLoaded = true;
          callback();
        });
  }

  private routerToSaleProduct(productCategory: ProductCategory) {
    return {
      name: RouteNames.cbSales,
      query: { ...this.$route.query, "type-of-product": productCategory.type },
      params: {
        convocationId: this.id,
        productTypeId: productCategory.id
      }
    };
  }
}
